import { useState } from 'react';
import { ICarrito } from '@/redux/models';
import { useTablaCarpetaContext } from '../logics/TablaCarritoProvider';
import TableRowComponent from './TableRowComponents/TableRowComponent';




const TableRows = ({ visibleRows }: { visibleRows: ICarrito[] }) => {
    const { context } = useTablaCarpetaContext();
    const { isCarpetaSelected } = context;
    const [rowsOpen, setRowsOpen] = useState<number[]>([]);

    const handleOpenRow = (id: number) => {

        if (rowsOpen.includes(id)) {
            setRowsOpen((prev) => [...prev.filter((prevId) => prevId !== id)]);
        } else {
            setRowsOpen([...rowsOpen, id]);
        }
    }

    return (
        <>
            {visibleRows.map((carpeta, index) => {
                const isSelected = isCarpetaSelected(carpeta);
                const isInformesOpen = rowsOpen.includes(carpeta.idCarrito);

                return (
                    <TableRowComponent
                        rowsOpen={rowsOpen}
                        context={context}
                        key={carpeta.idCarrito}
                        carpeta={carpeta}
                        index={index}
                        isSelected={isSelected}
                        isInformesOpen={isInformesOpen}
                        handleOpenRow={handleOpenRow}
                    />
                );
            })}
        </>
    );
}

export default TableRows;
